/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Step_Submit_DescInputs */

const en_directory_submit_step_submit_desc = /** @type {(inputs: Directory_Submit_Step_Submit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core product details`)
};

const zh_directory_submit_step_submit_desc = /** @type {(inputs: Directory_Submit_Step_Submit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核心产品信息`)
};

/**
* | output |
* | --- |
* | "Core product details" |
*
* @param {Directory_Submit_Step_Submit_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_step_submit_desc = /** @type {((inputs?: Directory_Submit_Step_Submit_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Step_Submit_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_step_submit_desc(inputs)
	return zh_directory_submit_step_submit_desc(inputs)
});
export { directory_submit_step_submit_desc as "directory.submit.step_submit_desc" }